import { ContainerCard } from "../../../components/cards/containerCard";
import { InvitationCard } from "../../../components/cards/invitationCard";
import { InvitationCardLoader } from "../../../components/loaders/invitationCardLoader";
import { EmptyState } from "../../../components/states/emptyState";
import { PageTitle } from "../../../components/typography/pageTitle";
import { useFetchInvitationsQuery } from "../../../redux/features/cooperative/cooperative.api";

export const Invitation = () => {
  const {
    data: invitations,
    isLoading: fetchingInvitations,
    refetch: refetchInvitations,
  } = useFetchInvitationsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <div className="w-full">
      <PageTitle
        text="Invitations"
        subtext="Manage all your cooperative membership invitations in one place"
        containerClassName="max-md:hidden"
      />

      <div className="md:mt-6">
        {fetchingInvitations ? (
          <InvitationCardLoader count={5} />
        ) : (
          <div className="flex flex-col gap-4">
            {[0, undefined, ""].includes(invitations?.data?.length) && (
              <ContainerCard className=" !py-14">
                <EmptyState
                  image={
                    <img
                      src={`/assets/images/empty_state_invite.svg`}
                      alt="empty_state"
                    />
                  }
                  title="You have no invitations"
                  subtitle="All your invitations will be displayed here whenever you are invited to join any cooperative"
                />
              </ContainerCard>
            )}

            {(invitations?.data?.length ?? 0) > 0
              ? invitations?.data?.map((invitation, idx) => {
                  const key = `invitation-${idx}`;
                  return (
                    <InvitationCard
                      key={key}
                      invitation={invitation}
                      onSuccess={() => {
                        refetchInvitations();
                      }}
                    />
                  );
                })
              : undefined}
          </div>
        )}
      </div>
    </div>
  );
};
